import { Box, Stepper as StepperMui, Step } from '@mui/material';

import type { StepperProps } from './types';
import { QontoConnector, StyledStepLabel } from './styles';

export function Stepper({
  steps,
  activeStep = 0,
  onClickStep,
}: Readonly<StepperProps>) {
  return (
    <Box sx={{ width: '100%' }}>
      <StepperMui
        activeStep={activeStep}
        alternativeLabel
        connector={<QontoConnector />}
      >
        {steps.map((label, index) => {
          const hasPreviousStep = activeStep > index;
          const cursorStyle =
            hasPreviousStep && onClickStep ? 'pointer' : 'default';

          return (
            <Step
              key={label}
              onClick={() => hasPreviousStep && onClickStep?.(index)}
              sx={{
                cursor: cursorStyle,
              }}
            >
              <StyledStepLabel>{label}</StyledStepLabel>
            </Step>
          );
        })}
      </StepperMui>
    </Box>
  );
}
